/* Parkfield - offers slide out */

function openSpecialOffers() {
  document.querySelector("#offer-flyout").classList.add("open");
}

function closeSpecialOffers() {
  document.querySelector("#offer-flyout").classList.remove("open");
}

function closeSpecialOffersParent(event) {
  if (!event.target.closest(".offer-flyout.inner-container")) {
    document.querySelector("#offer-flyout").classList.remove("open");
  }
}


/* Product page - fix theme variant selector and remember selection between sizes and diff products - NICO */

function fixThemesVariantSelector(evt) {
  const formId = evt.detail?.formId || evt.target.id;
  const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
  if (!variantPicker) return;

  // Sold-out variants are valid selections. Only recover from a combination that does not exist.
  if (evt.detail?.variant?.id) {
    saveSelectedVariant(variantPicker);
    return;
  }

  restoreSize(variantPicker);
}

document.addEventListener("variant:change", (evt) =>
  fixThemesVariantSelector(evt)
);


function saveSelectedVariant(variantPicker) {
  const sizeTypeFieldset = variantPicker.querySelector('.variant-picker__option.option-Size-Type');
  const sizeFieldset = variantPicker.querySelector('.variant-picker__option.option-Size');

  if (sizeTypeFieldset) {
    const checkedSizeType = sizeTypeFieldset.querySelector('input[type="radio"]:checked');
    if (checkedSizeType) {
      const sizeTypeValue = checkedSizeType.dataset.value;
      localStorage.setItem('savedSizeType', sizeTypeValue);

      if (sizeFieldset) {
        const checkedSize = sizeFieldset.querySelector('input[type="radio"]:checked');
        if (checkedSize) {
          const sizeValue = checkedSize.dataset.value;
          // Save size per sizeType
          let savedSizes = JSON.parse(localStorage.getItem('savedSizesByType') || '{}');
          savedSizes[sizeTypeValue] = sizeValue;
          localStorage.setItem('savedSizesByType', JSON.stringify(savedSizes));
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productMeta = document.getElementById("product-meta");
  if (!productMeta) return;

  // Respect links to a specific size, including sold-out sizes.
  if (new URL(window.location.href).searchParams.has('variant')) return;

  // A type change rerenders asynchronously; recover its size after the variant-change event.
  if (!restoreType()) restoreSize();
});

function restoreType() {
  const savedSizeTypeVal = localStorage.getItem('savedSizeType');
  if (savedSizeTypeVal) {
    const variantPicker = document.querySelector('variant-picker');
    const matchingType = variantPicker?.querySelector(`input[type="radio"][data-value="${CSS.escape(savedSizeTypeVal)}"]`);
    if (matchingType && !matchingType.disabled && !matchingType.checked) {
      matchingType.click();
      return true;
    }
  }
  return false;
}

function restoreSize(variantPicker = document.querySelector('variant-picker')) {
  if (!variantPicker) return;
  const sizeTypeFieldset = variantPicker.querySelector('.variant-picker__option.option-Size-Type');
  const checkedSizeType = sizeTypeFieldset?.querySelector('input[type="radio"]:checked');
  const currentSizeType = checkedSizeType?.dataset.value;

  if (!currentSizeType) return;

  let savedSizes = JSON.parse(localStorage.getItem('savedSizesByType') || '{}');
  const savedSizeVal = savedSizes[currentSizeType];

  if (savedSizeVal) {
    const matchingSize = variantPicker.querySelector(`input[type="radio"][data-value="${CSS.escape(savedSizeVal)}"]`);
    const matchingLabel = matchingSize?.nextElementSibling;
    if (matchingSize && matchingLabel && !matchingSize.disabled && !matchingLabel.hidden) {
      if (!matchingSize.checked) matchingSize.click();
      return;
    }
  }

  // Prefer an in-stock size, then an existing sold-out size if the entire size type is sold out.
  const fallback = variantPicker.querySelector('input[data-option-position="2"]:not(:disabled) + label:not([hidden]):not(.is-disabled)')
    || variantPicker.querySelector('input[data-option-position="2"]:not(:disabled) + label:not([hidden])');
  const fallbackInput = fallback?.previousElementSibling;
  if (fallbackInput && !fallbackInput.checked) fallbackInput.click();
}

